var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

require('selectize/dist/js/standalone/selectize.js');
require('selectize/dist/css/selectize.css');
var moment = require('moment');

var DateTimePicker = require('front/components/DateTimePicker/DateTimePicker');

require('./ArchiveFilters.less');

module.exports = Backbone.View.extend({
    el: '.ArchiveFilters',

    initialize: function (options) {
        _.bindAll(this, 'setArchiveURL', 'onStartDateChanged', 'onEndDateChanged');
        this.startDate = options.start;
        this.endDate = options.end;
        this.project = options.project || '';
        this.hideButton = options.hideButton || false;
        this.$('.ArchiveFilters-project').selectize({
            allowEmptyOption: true,
            // by default selectize doesn't remove selected from items
            onChange: function (val) {
                this.$('.selectize-dropdown-content .option').removeClass('selected');
                this.$('.selectize-dropdown-content .option[data-value="' + val + '"]').addClass('selected');
                this.project = val;
                this.setArchiveURL();
            }.bind(this)
        });
        this.$('.ArchiveFilters-project .selectize-input input').attr('disabled', 'disabled');

        this.start = new DateTimePicker({
            el: this.$('.DateTimePicker[data-name=start]'),
            timepicker: false,
            format: 'Ymd',
            changeTime: false
        });
        this.start.on('change', this.onStartDateChanged);
        this.end = new DateTimePicker({
            el: this.$('.DateTimePicker[data-name=end]'),
            timepicker: false,
            format: 'Ymd',
            changeTime: false
        });
        this.end.on('change', this.onEndDateChanged);

        moment.locale('ru');
    },

    setArchiveURL: function () {
        var url = '/efir/archive/?project=' + this.project + '&start=' + this.startDate + '&end=' + this.endDate;
        if (this.hideButton) document.location.href = url;
        else this.$('.ArchiveFilters-filter').attr('href', url);
    },

    onStartDateChanged: function (value) {
        this.startDate = moment(value).format('YMMDD');
        this.setArchiveURL();
    },

    onEndDateChanged: function (value) {
        this.endDate = moment(value).format('YMMDD');
        this.setArchiveURL();
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ArchiveFilters/ArchiveFilters.js
// module id = 19
// module chunks = 0